<template>
    <el-select ref="selectDom" :placeholder="placeholder" @blur.native.capture="blur" v-model="selectedValue" clearable :filterable="filterable" :disabled="disabled" @change="handleChange">
        <el-option v-for="item in normalizedOptions" :key="item.optionValue" :label="item.Text" :value="item.optionValue">
            {{item.Text}}
        </el-option>
    </el-select>
</template>

<script type="text/javascript">
export default {
    name: "RtPicklist",
    props: {
        value: [String, Number],
        entity: {
            type: String,
            required: true
        },
        attribute: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        filterable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedValue: null,
            options: [],
            syncing: false
        }
    },
    computed: {
        normalizedOptions() {
            return this.options.map((item) => {
                return Object.assign({}, item, {
                    optionValue: this.normalizeValue(item.Value)
                });
            });
        }
    },
    watch: {
        value(newVal) {
            this.syncSelectedValue(newVal);
        }
    },
    methods: {
        normalizeValue(value) {
            if (value === null || value === undefined || value === "") {
                return value;
            }
            return String(value);
        },
        syncSelectedValue(value) {
            // 同步外部值时避免触发 el-select change，防止必填校验误报红框
            this.syncing = true;
            this.selectedValue = this.normalizeValue(value);
            this.$nextTick(() => {
                this.syncing = false;
            });
        },
        bindPicklist: function () {
            var self = this;
            rt.get("../api/crmpicklist/options/" + this.entity + "/" + this.attribute)
                .then(function (res) {
                    self.options = res;

                    // 发射 options-loaded 事件，允许父组件自定义处理选项
                    self.$emit("options-loaded", self.options);

                    self.$nextTick(function () {
                        self.syncSelectedValue(self.value);
                    });
                });
        },
        handleChange(val) {
            if (this.syncing) {
                return;
            }
            var selectedOption = this.normalizedOptions.find(function (item) {
                return item.optionValue === val;
            });
            var emitValue = selectedOption ? selectedOption.Value : val;

            this.$emit("input", emitValue);

            this.$emit("change", emitValue);
        },
        blur(){
            setTimeout(()=>{
                this.$refs.selectDom.blur();
            },300)
        }
    },
    mounted: function () {
        this.syncSelectedValue(this.value);
        this.bindPicklist();
    }
}
</script>



// WEBPACK FOOTER //
// main.vue?177ed55d